import React, { useEffect, useLayoutEffect, useRef } from 'react'
import { observer } from "mobx-react-lite"
import styles from './FilterBar.module.scss'
import clsx from 'clsx'
import BpmFilter from './BpmFilter'
import MajorMinorFilter from './MajorMinorFilter'
import InstrumentFilter from './InstrumentFilter'

import FacebookIcon from '@mui/icons-material/Facebook'
import TwitterIcon from '@mui/icons-material/Twitter'
import IconButton from '@mui/material/IconButton'

import SearchFilter from './SearchFilter'

const Share = ({show}) => {
  if (!show) {
    return null
  }
  return <div className={styles['share']}>
    <IconButton><TwitterIcon /></IconButton>
    <IconButton><FacebookIcon /></IconButton>
  </div>
}

const FilterBar = ({className, start, end, showInstrument, model}) => {
  const classes = {button: styles['filter-btn']}
  const domRef = useRef(null)
  useLayoutEffect(() => {
    const stop = (e) => {
      e.stopPropagation()
    }
    domRef.current.addEventListener('keydown', stop, false)
    return () => {
      domRef.current.addEventListener('keydown', stop, false)
    }
  }, [])
  return <div ref={domRef} className={clsx(styles['root'], className)}>
    <div className={styles.left}>
      {start}
      <BpmFilter classes={classes} model={model} />
      {showInstrument && model.pack.instruments && model.pack.instruments.length > 0 && <InstrumentFilter  classes={classes} model={model} instruments={model.pack.instruments}/>}
      <MajorMinorFilter classes={classes} model={model} />
    </div>
    <div className={styles.right}>
      {end}
      <SearchFilter model={model} />
    </div>
  </div>
}

export default observer(FilterBar)